import {
  Box,
  Flex,
  Select,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Button,
  Stack,
  Spinner,
  Badge,
  useColorModeValue,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Grid,
  GridItem,
  Icon,
  Avatar,
} from "@chakra-ui/react";
import { FaSync, FaPrint, FaClock, FaBook } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { MdSchool, MdPeople, MdPerson } from "react-icons/md";
import ExamDetails from "../../Class/Individual/ExamDetails";
import Bus_Create_form from "../BusCreation/Bus_Create_form";
import Bus_Table from "../BusCreation/Bus_Table";
import BusTable from "../BusCreation/Bus_Table";
import Route_create from "../BusRoute/Route_create";
import RoutTable from "../BusRoute/Rout_Table";
import Rout_Table from "../BusRoute/Rout_Table";
import Create_Driver from "../Driver/Create_Driver";
import List_Driver from "../Driver/List_Driver";
import AllocateModal from "./Allocate_students";
import Allocate_students from "./Allocate_students";
import Allocate_Table from "./Allocate_Table";
import RouteStudentsTable from "./Allocate_Table";
// import Fine_Modal from "./Fine_Modal";
//   import Print_pdf_classDetails from "./Print_pdf_classDetails";

const Allocate_details = () => {
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [students, setStudents] = useState([]);
  const printComponentRef = useRef();

  return (
    <Box maxWidth="100%">
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>
            Allocate To Bus
          </h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}>
            <div className="export-dropdown">
              {/* <Fine_Modal /> */}
              {/* Add a Button to trigger the  Modal */}
            </div>
          </div>
        </div>

        <Box className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Bus </span> /
          <Link
            to="/class/classlist"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Allocation  Details</span>
          </Link>
        </Box>
      </div>

      <Box p={6} flex="2" mb={9}>
        <Tabs
          variant="soft-rounded"
          colorScheme="teal"
          isFitted
          p={2}
          // boxShadow="lg"
          borderRadius="md"
          bg={useColorModeValue("white", "gray.700")}
        >
          <TabList display="flex" justifyContent="space-between" w="100%">
            <Tab
              _selected={{
                bg: useColorModeValue("teal.100", "teal.600"),
                color: "teal.800",
                fontWeight: "bold",
                borderRadius: "md",
              }}
              py={2}
              flex="1" // Ensures the tab takes equal space
            >
              Allocate 
            </Tab>
            <Tab
              _selected={{
                bg: useColorModeValue("teal.100", "teal.600"),
                color: "teal.800",
                fontWeight: "bold",
                borderRadius: "md",
              }}
              py={2}
              flex="1" // Ensures the tab takes equal space
            >
              View
            </Tab>
          </TabList>

          <TabPanels>
            <TabPanel p={0} mt="10px">
              <Allocate_students />
            </TabPanel>

            <TabPanel p={0} mt="10px">
              <RouteStudentsTable />
            </TabPanel>

            <TabPanel p={0}>
              {/* Add any other components or content here */}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
};

export default Allocate_details;
